import React, { useState } from "react";
import { useTable, useSortBy, useResizeColumns, useFlexLayout } from "react-table";

import s from "../../admin_styles/UserSearch.module.css";
import ProjectList from "../ProjectList";
// import UserPayHistory from "./UserPayHistory";
import UserFullInfoModal from "./UserFullInfoModal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import CommentModal from "./CommentModal";


export default function UserTableList({ users, setUsers, selectedUsers, setSelectedUsers }) {
  const [activeUserId, setActiveUserId] = useState(null);
  const [modalType, setModalType] = useState(null);
  const [selectAll, setSelectAll] = useState(false);

  const handleOpenProjects = (userId) => {
    setActiveUserId(userId);
    setModalType("projects");
  };

  const handleOpenPayHistory = (userId) => {
    setActiveUserId(userId);
    setModalType("history");
  };

  const handleCloseModal = () => {
    setActiveUserId(null);
    setModalType(null);
  };

    const toggleSelectAll = () => {
    if (selectAll) {
      setSelectedUsers([]);
    } else {
      setSelectedUsers(users); // сохраняем полный объект
    }
    setSelectAll(!selectAll);
  };

  const toggleSelectOne = (user) => {
    if (selectedUsers.some((u) => u.id === user.id)) {
      setSelectedUsers(selectedUsers.filter((u) => u.id !== user.id));
    } else {
      setSelectedUsers([...selectedUsers, user]);
    }
  };


  const data = React.useMemo(() => users, [users]);

  const columns = React.useMemo(
    () => [
      {
        Header: (
          <input type="checkbox" checked={selectAll} onChange={toggleSelectAll} />
        ),
        accessor: "select",
        width: 32,
      Cell: ({ row }) => {
        const isChecked = selectedUsers.some((u) => u.id === row.original.id);

        return (
          <div
            className={s.selectCell}
            onClick={(e) => {
              e.stopPropagation(); // Не даём всплывать клику на строку
              toggleSelectOne(row.original);
            }}
            style={{ cursor: "pointer", display: "flex", alignItems: "center" }}
          >
            <input
              type="checkbox"
              checked={isChecked}
              onChange={() => toggleSelectOne(row.original)}
              onClick={(e) => e.stopPropagation()} // Тоже останавливаем всплытие
            />
          </div>
        );
      }
      },
      { Header: "ID", accessor: "id", width: 30 },
      { Header: "Логин", accessor: "login", width: 146 },
      { Header: "Имя", accessor: "name", width: 89 },
      {
        Header: "TG ник",
        accessor: "tgnikname",
        width: 98,
        Cell: ({ value }) =>
          value ? (
            <a
              href={`https://t.me/${value}`}
              target="_blank"
              rel="noopener noreferrer"
              onClick={(e) => e.stopPropagation()}
            >
              {value}
            </a>
          ) : (
            "-"
          ),
      },
      { Header: "TG имя", accessor: "tg_name", width: 118 },
      {
        Header: "Комментарий",
        accessor: "comment",
        width: 90,
        Cell: ({ row, value }) => {
          return (
            <div
              onClick={(e) => {
                e.stopPropagation();
                setActiveUserId(row.original.id);
                setModalType("comment");
              }}
              style={{
                width: "100%",          // 🔥 занимает всю ячейку
                height: "100%",         // 🔥 занимает всю высоту
                display: "flex",        // 🔥 растягивает контент
                alignItems: "center",
                cursor: "pointer",
                padding: "0 6px",       // чтобы было куда кликать
                boxSizing: "border-box",
              }}
            >
              <span
                style={{
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  width: "100%",
                }}
              >
                {value ? value.slice(0, 20) + "..." : "-"}
              </span>
            </div>
          );
        },
      },
      { Header: "TG ID", accessor: "tg_user_id", width: 31 },
      { Header: "Реферал", accessor: "referrer_code", width: 61 },
      {
        Header: "Регистрация",
        accessor: "reg_date",
        width: 74,
        Cell: ({ value }) => (value ? value.split("T")[0] : "-"),
      },
      // { Header: "Проектов", accessor: "project_count", width: 58 },
      {
        Header: "Проектов",
        id: "project_count",
        // сортировка будет по этому значению (итого)
        accessor: (row) => Number(row.project_count ?? 0),
        width: 68,
        Cell: ({ row, value }) => {
          const active = Number(row.original.projects_active ?? 0);
          const archived = Number(row.original.projects_archived ?? 0);
          return (
            <span>
              {value}
              {" ("}
              {active}
              {"/"}
              <span style={{ color: "#e11d48" }}>{archived}</span>
              {")"}
            </span>
          );
        },
      },
      { Header: "Тариф", accessor: "tariff_name", width: 60 },
      {
        Header: "Баланс",
        accessor: "balance",
        width: 60,
        Cell: ({ value }) => (value !== null ? `${value} ₽` : "-"),
      },
      {
        Header: "Дней хватит",
        accessor: "days_left",
        width: 76,
        Cell: ({ value }) => (value !== null ? value : "-"),
      },
      { Header: "Триал до", accessor: "trial_until", width: 75 },
      {
        Header: "Действия",
        id: "actions",
        width: 133,
        Cell: ({ row }) => (
          <div className={s.deystviya_div}>
            <button
              className={s.deystviya_button}
              onClick={(e) => {
                e.stopPropagation();
                handleOpenProjects(row.original.id);
              }}
            >
              Проекты
            </button>
            <button
              className={s.deystviya_button}
              onClick={(e) => {
                e.stopPropagation();
                handleOpenPayHistory(row.original.id);
              }}
            >
              Платежи
            </button>
          </div>
        ),
      },
    ],
    [selectAll, selectedUsers, setActiveUserId, setModalType]
  );

  const defaultColumn = React.useMemo(
    () => ({
      minWidth: 30,
      width: 150,
      maxWidth: 400,
    }),
    []
  );

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } = useTable(
    { columns, data, defaultColumn },
    useSortBy,
    useFlexLayout,
    useResizeColumns
  );

  if (!users || users.length === 0) return <p>Нет результатов</p>;

  return (
    <div className={s.tableWrapper} {...getTableProps()}>
      <div>
        {/* {headerGroups.map((headerGroup) => (
          <div {...headerGroup.getHeaderGroupProps()} className={`${s.tr} ${s.headerRow}`}>
            {headerGroup.headers.map((column) => (
              <div {...column.getHeaderProps()} className={s.th}>
                {column.render("Header")}
                <div {...column.getResizerProps()} className={s.resizer} />
              </div>
            ))}
          </div>
        ))} */}
        {headerGroups.map((headerGroup) => (
            <div {...headerGroup.getHeaderGroupProps()} className={s.tr + " " + s.headerRow}>
                {headerGroup.headers.map((column) => (
                <div
                    // {...column.getHeaderProps(column.getSortByToggleProps())}
                      {...column.getHeaderProps(
                          column.id === "select" ? undefined : column.getSortByToggleProps()
                        )}
                    className={s.th}
                >
                    {column.render("Header")}
                    <span>
                    {column.isSorted
                        ? column.isSortedDesc
                        ? " 🔽"
                        : " 🔼"
                        : ""}
                    </span>
                    <div {...column.getResizerProps()} className={s.resizer} />
                </div>
                ))}
            </div>
            ))}
      </div>

      <div {...getTableBodyProps()}>
        {rows.map((row) => {
          prepareRow(row);
          const isVip = row.original.days_left > 0;
          return (
            <div
              {...row.getRowProps()}
              className={`${s.tr} ${isVip ? s.rowGreen : ""}`}
              onClick={() => handleOpenProjects(row.original.id)}
            >
              {row.cells.map((cell) => (
                <div {...cell.getCellProps()} className={s.td}>
                  {cell.render("Cell")}
                </div>
              ))}
            </div>
          );
        })}
      </div>

      {activeUserId && modalType === "projects" && (
        <div className={s.modalOverlay}>
          <div className={s.modalContent}>
            <button className={s.modalClose} onClick={handleCloseModal}>
              <FontAwesomeIcon icon={faTimesCircle} />
            </button>
            <ProjectList userId={activeUserId} />
          </div>
        </div>
      )}

      {activeUserId && modalType === "history" && (
        <div className={s.modalOverlay}>
          <div className={s.modalContent}>
            {/* <button className={s.modalClose} onClick={handleCloseModal}>
              <FontAwesomeIcon icon={faTimesCircle} />
            </button> */}
            {/* <UserPayHistory userId={activeUserId} /> */}
            <UserFullInfoModal
                      userId={activeUserId}
                      onClose={handleCloseModal}
                    />

          </div>
        </div>
      )}

      {activeUserId && modalType === "comment" && (
        <CommentModal
          userId={activeUserId}
          users={users}
          setUsers={setUsers}
          onClose={handleCloseModal}
        />
      )}
    </div>
  );
}
